export default __webpack_public_path__ + "static/media/average_icon.bfb20119.svg";